import { ReactNode } from 'react';

export interface InternalSrOnlyProps {
  children: ReactNode;
  id?: string;
}

export function SrOnly({ children, id }: InternalSrOnlyProps) {
  return (
    <span
      css={{
        border: 0,
        clip: 'rect(0,0,0,0)',
        height: '1px',
        margin: '-1px',
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        whiteSpace: 'nowrap',
        width: '1px',
      }}
      id={id}
    >
      {children}
    </span>
  );
}
